import { render, staticRenderFns } from "./HomeworkWriteInfoToolbar.vue?vue&type=template&id=5ef1a803&scoped=true"
import script from "./HomeworkWriteInfoToolbar.vue?vue&type=script&lang=js"
export * from "./HomeworkWriteInfoToolbar.vue?vue&type=script&lang=js"
import style0 from "./HomeworkWriteInfoToolbar.vue?vue&type=style&index=0&id=5ef1a803&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef1a803",
  null
  
)

export default component.exports